import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TogglePersonApprovalMutationVariables = Types.Exact<{
  input: Types.TogglePersonApprovalInput;
}>;

export type TogglePersonApprovalMutation = {
  __typename?: 'Mutation';
  togglePersonApproval: {
    __typename?: 'TogglePersonApprovalResponse';
    message: string;
    success: boolean;
  };
};

export const TogglePersonApprovalDocument = gql`
  mutation TogglePersonApproval($input: TogglePersonApprovalInput!) {
    togglePersonApproval(input: $input) {
      message
      success
    }
  }
`;
export type TogglePersonApprovalMutationFn = Apollo.MutationFunction<
  TogglePersonApprovalMutation,
  TogglePersonApprovalMutationVariables
>;
export function useTogglePersonApprovalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TogglePersonApprovalMutation,
    TogglePersonApprovalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TogglePersonApprovalMutation,
    TogglePersonApprovalMutationVariables
  >(TogglePersonApprovalDocument, options);
}
export type TogglePersonApprovalMutationHookResult = ReturnType<
  typeof useTogglePersonApprovalMutation
>;
export type TogglePersonApprovalMutationResult =
  Apollo.MutationResult<TogglePersonApprovalMutation>;
export type TogglePersonApprovalMutationOptions = Apollo.BaseMutationOptions<
  TogglePersonApprovalMutation,
  TogglePersonApprovalMutationVariables
>;
